import { createSlice } from '@reduxjs/toolkit'

const initialState = { showAppBar: true }

const appbarSlice = createSlice({
  name: 'Appbar',
  initialState,
  reducers: {
    setShowAppBar(state, action) {
      state.showAppBar = action.payload
    },
  },
})

export const { setShowAppBar } = appbarSlice.actions
export default appbarSlice.reducer
